import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";


@Entity('fg_stock_transfer')
export class fgStockTransfer{
    
    @PrimaryGeneratedColumn("increment",{name:"transfer_type_id"})
    transferType:number;
    @Column("varchar",{
        nullable:false,
        name:"from_location"
    })
    fromlocation:string;
    @Column("int",{
        nullable:false,
        name:"so_number"
    })
    date: Date;
    @Column("boolean",{
        nullable:false,
        default:false,
        name:"sync_status"
        })
    syncStatus?:boolean;
    
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default:"Admin",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
    
}